import { render, staticRenderFns } from "./VehicleStatusSelector.vue?vue&type=template&id=56600265&"
import script from "./VehicleStatusSelector.vue?vue&type=script&lang=js&"
export * from "./VehicleStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatusSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports